// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetProductRealTimeInventoryApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import {chain, FindWarehouseData } from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import { ProductInventoryDto, WarehouseDto } from "@insite/client-framework/Types/ApiModels";

export interface XRealTimeInvResult {
    errorMessage: string;
    warehouses?: WarehouseDto[];
    additionalResult?: {[key: string]: string} | null;
}

type HandlerType = Handler<
    GetProductRealTimeInventoryApiV2Parameter & {
        onComplete: (result: XRealTimeInvResult) => void;
        unitOfMeasure: string;
    },
    {
        apiParameter: GetProductRealTimeInventoryApiV2Parameter;
        apiResult?: ProductInventoryDto;
        result: XRealTimeInvResult;
    }
>;

export const XFindWarehouseData: HandlerType = props => {
    props.result = {
        errorMessage: "Inventory is not currently available",
    };

    if (props.apiResult && props.apiResult.inventoryWarehousesDtos) {
        const inventoryWarehousesDto = props.apiResult.inventoryWarehousesDtos.find(
            o => o.unitOfMeasure.toLowerCase() === props.parameter.unitOfMeasure.toLowerCase(),
        );

        if (inventoryWarehousesDto && inventoryWarehousesDto.warehouseDtos) {
            // XNG-Change: Add additional result
            props.result = {
                warehouses: inventoryWarehousesDto.warehouseDtos,
                errorMessage: "",
                additionalResult: props.apiResult.additionalResults
            };
        }
    }
};

replaceInChain(chain, FindWarehouseData, XFindWarehouseData)